import React from 'react';

const TicketIcon = (props) => {
  return (
    <img
      alt="Atrakcja"
      src="/static/images/icons/place_types/ticket.svg"
      {...props}
    />
  );
};

export default TicketIcon;
